import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';


const OCR = () => {

    let navigate = useNavigate();
    const location = useLocation();
    const cameraInputRef = useRef(null);
    const fileInputRef = useRef(null);

    const [files, setFiles] = useState(null);
    const [isScanning, setIsScanning] = useState(false);

    const backendURL = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        if (!location.state) {
            navigate('/');
        }
    }, []);

    const handleFileClick = () => {
        cameraInputRef.current.click();
    };

    const handleAddFileClick = () => {
        fileInputRef.current.click();
    };

    const handleFilesChange = (event) => {
        const selectedFile = event.target.files?.[0];
        if (!selectedFile) return;
        setFiles(selectedFile);
        event.target.value = "";
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!files) {
            toast.warn("Please upload an image");
            return;
        }

        const formData = new FormData();
        formData.append("images", files);
        setIsScanning(true);

        try {
            const response = await fetch(`${backendURL}process`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                toast.error("Failed to send image data");
                return;
            }

            else {
                const ocrResult = await response.json();

                // No cards found or parse failed
                if (!ocrResult.cards || ocrResult.cards_found === 0) {
                    toast.warn("No business cards found. Please upload a proper image.");
                    return;
                }

                // All cards have every value null → bad image
                if (ocrResult.cards.every(card =>
                    Object.values(card).every(v => v === null || v === undefined)
                )) {
                    toast.warn("Please upload an image of a Business Card");
                    return;
                }

                // Single card → go directly to Edit
                if (ocrResult.cards_found === 1) {
                    navigate('/display', { state: { ocrResult: ocrResult.cards[0] } });
                }

                // Multiple cards → go to a new card selection page
                else {
                    navigate('/select-card', { state: { cards: ocrResult.cards } });
                }
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error("Please upload a proper image of a Business Card");
        }
        finally {
            setIsScanning(false);
        }
    };

    return (
        <>
            <div className="bg-custom-bg bg-cover bg-center min-h-screen flex items-center justify-center px-4">
                <div className="relative z-10 shadow-xl rounded-xl p-8 w-full max-w-2xl">
                    <div className="playwrite custom-font text-2xl font-bold text-center text-green-800 mb-2">Scan Your Card Images</div>
                    <div className="text-sm text-blue-700 text-center mb-6">Upload or capture an image containing one or more business cards</div>

                    <form id="upload-form" className="space-y-4" encType="multipart/form-data" onSubmit={handleSubmit}>
                        <div className="flex items-center justify-between md:justify-around">
                            <div className='md:hidden'>
                                <input
                                    type="file"
                                    capture="environment"
                                    ref={cameraInputRef}
                                    accept="image/*"
                                    className="hidden"
                                    onChange={handleFilesChange}
                                />
                                <button type="button" className="input-ocr" onClick={handleFileClick}>Click Image</button>
                            </div>

                            <div className='text-green-700 font-bold md:hidden'>or</div>

                            <div>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    accept="image/*"
                                    className="hidden"
                                    onChange={handleFilesChange}
                                />
                                <button type="button" className="input-ocr" onClick={handleAddFileClick}>Upload Image</button>
                            </div>
                        </div>

                        {/* <ul id="file-list" className="text-sm text-green-600">
                            {files.map((file, index) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul> */}

                        <ul id="file-list" className="text-sm text-green-600">
                            {files && (
                                <li>{files.name}</li>
                            )}
                        </ul>

                        <button
                            type="submit"
                            disabled={isScanning}
                            className={`w-full bg-[#095947] text-white font-bold py-2 px-4 rounded-lg transition 
                            ${isScanning ? 'opacity-50 cursor-not-allowed' : 'active:bg-green-900'}`}
                        >
                            {isScanning ? "Scanning..." : "Start Scanning"}
                        </button>

                    </form>
                </div>
            </div>
        </>
    )
}

export default OCR
